import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import QS from 'qs'

import { baseURL } from 'utils/io'
import { getDomains } from 'ducks/domains'
import { showModal, setPaymentRouteType } from 'ducks/trialWarning'
import SettingsFormField from '../../../Shared/Forms/SettingsFormField'
import Button from '../../../Shared/Button'
import DomainPicker from '../DomainPicker'

const asyncValidate = async app => {
  try {
    const query = QS.stringify({
      path: app.path || '',
      organizationId: app.Organization.id,
      appId: app.id,
      domainId: app.DomainId,
    })

    const url = `${baseURL}/organizations/path-availability?${query}`
    await axios.get(url)
  } catch (err) {
    throw { path: `This URL is already in use by another app.` }
  }
}

const validate = ({ path }) => {
  const errors = {}

  if (path && path.match(/[^a-z\d\-_]/)) {
    errors.path = 'Can only include letters, numbers, and dashes'
  }

  return errors
}

class WebPublishForm extends Component {
  handleShowModal = e => {
    e.preventDefault()

    const { showModal, setPaymentRouteType } = this.props

    setPaymentRouteType('upgrade')
    showModal()
  }

  renderURL() {
    const { app, getAppHost } = this.props
    const protocol = window.location.protocol
    let url = getAppHost()

    url = `${url}${app.path || ''}`

    return (
      <div className="web-publish-url-box">
        <div className="settings-form-row">
          <label>Published On</label>
          <p className="settings-form-static-value">{url}</p>
        </div>
        <div className="web-publish-open-url">
          <Button green to={`${protocol}//${url}`} target="_blank">
            Open
          </Button>
        </div>
      </div>
    )
  }

  render() {
    const {
      handleSubmit,
      dirty,
      submitting,
      app,
      needUpgrade,
      domainId,
      getAppHost,
    } = this.props

    return (
      <div>
        <form onSubmit={handleSubmit}>
          {needUpgrade ? (
            <div className="settings-form-row">
              <label>Domain</label>
              <div className="">
                <p className="publish-form-note">
                  In order to add a custom domain, you need to upgrade to a paid
                  plan.
                </p>
                <div className="settings-form-inline-submit">
                  <Button green type="button" onClick={this.handleShowModal}>
                    Upgrade Now
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <DomainPicker appId={app?.id} />
          )}
          <Field
            label={getAppHost(domainId)}
            name="path"
            component={SettingsFormField}
            autoComplete="off"
          />
          <div className="settings-form-inline-submit">
            <Button green loading={submitting} disabled={!dirty || submitting}>
              Save
            </Button>
          </div>
        </form>
        {this.renderURL()}
      </div>
    )
  }
}

const selector = formValueSelector('web-publish-settings')

const mapStateToProps = (state, { app }) => ({
  domainId: selector(state, 'DomainId'),
  domains: getDomains(state, app.Organization.id),
})

export default connect(mapStateToProps, { showModal, setPaymentRouteType })(
  reduxForm({
    form: 'web-publish-settings',
    asyncValidate,
    validate,
  })(WebPublishForm)
)
